import { render, staticRenderFns } from "./role.vue?vue&type=template&id=3a8061d1&scoped=true&"
import script from "./role.vue?vue&type=script&lang=ts&"
export * from "./role.vue?vue&type=script&lang=ts&"
import style0 from "./role.vue?vue&type=style&index=0&id=3a8061d1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8061d1",
  null
  
)

export default component.exports